import { LookupItem } from "@data-types";
import { EstimatedGamingAmountDataType } from "@data-types/membership/registration";
import { ISOToDisplayCode } from "@utils/common";
import { THEME_SETTINGS } from "@theme-settings";

export function sortByNameLocale<T extends LookupItem>(items: T[]): T[] {
	return items.sort((a, b) => a.name.localeCompare(b.name));
}

export function sortAndPrepareEstimatedGamingAmounts(
	items: EstimatedGamingAmountDataType[]
): EstimatedGamingAmountDataType[] {
	return items
		.sort((a, b) => a.sortOrder - b.sortOrder)
		.map((data) => {
			data.span =
				data.span +
				` ${ISOToDisplayCode(THEME_SETTINGS.defaultCurrency)}`;

			return data;
		});
}
